export function uuid4(): string {
  const crypto = window.crypto || (window as any).msCrypto;

  return '10000000100040008000100000000000'.replace(/[018]/g, (c) => {
    const d = parseInt(c, 10);
    return (d ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (d / 4)))).toString(16);
  });
}
